import _ from 'lodash';
import React, { useState } from 'react';
import { useLocalStorage } from '../../util/hooks';
import KanbanBoard from './KanbanBoard';
import Pool from './Pool';
import '../../styles/kanban.scss';
import KanbanSearch from './KanbanSearch';

const Kanban = ({ name = '', pools = {}, setColumns, setColumnItems, columnItems, renderTemplate, onChange }) => {
  const [config, setConfig] = useLocalStorage(`kb-${name}`, {});
  const [searchTerms, setSearchTerms] = useState('');

  const handleSearch = value => {
    setSearchTerms(value);
  };

  return (
    <div className="kanban">
      <KanbanSearch onSearch={handleSearch} />
      {Object.keys(pools).map(poolName => {
        const columns = pools[poolName];

        if (searchTerms) {
          const searchText = _.toLower(searchTerms);
          Object.keys(columnItems).forEach(c => {
            const items = columnItems[c];

            if (items && items.length) {
              items.forEach(item => {
                item.found = false;

                Object.keys(item).forEach(key => {
                  if (_.includes(_.toLower(item[key]), searchText)) {
                    item.found = true;
                  }
                });
              });
            }
          });
        }

        return (
          <Pool key={poolName} title={poolName} isSearching={searchTerms !== ''}>
            <KanbanBoard
              columns={columns}
              config={config}
              onChange={onChange}
              renderTemplate={renderTemplate}
              setColumns={setColumns}
              setColumnItems={setColumnItems}
              columnItems={columnItems}
              setConfig={setConfig}
            />
          </Pool>
        );
      })}
    </div>
  );
};

export default Kanban;
